import styled from 'styled-components'

const FormLabel = styled.label`
    display: block;
    font-size: 90%;
    font-weight: 600;
    margin-bottom: 8px;
`

export default FormLabel
